var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationActiveClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#12ABBF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 11,
    r: 2,
    fill: "#FBA12B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 25.0817C24.7515 24.857 26.5784 24.4116 28.3112 23.7719C26.8744 22.177 25.9999 20.0656 25.9999 17.75V17.0492C26 17.0328 26.0001 17.0164 26.0001 17C26.0001 14.5574 24.5405 12.4557 22.4459 11.5195M22.8569 25.0817C21.9201 25.1928 20.9666 25.25 19.9999 25.25C19.0332 25.25 18.08 25.1929 17.1432 25.0818M22.8569 25.0817C22.9499 25.3711 23.0001 25.6797 23.0001 26C23.0001 27.6569 21.6569 29 20.0001 29C18.3432 29 17.0001 27.6569 17.0001 26C17.0001 25.6797 17.0503 25.3712 17.1432 25.0818M17.1432 25.0818C15.2485 24.857 13.4215 24.4116 11.6886 23.7719C13.1253 22.177 13.9999 20.0656 13.9999 17.75L14.0001 17C14.0001 14.5575 15.4596 12.4558 17.5541 11.5196M11.1245 15.5C11.4118 13.7876 12.1826 12.2392 13.2918 11M26.7084 11C27.8175 12.2392 28.5884 13.7876 28.8756 15.5M22.4459 11.5195C22.4814 11.3519 22.5 11.1781 22.5 11C22.5 9.61929 21.3807 8.5 20 8.5C18.6193 8.5 17.5 9.61929 17.5 11C17.5 11.1782 17.5186 11.352 17.5541 11.5196M22.4459 11.5195C22.2068 12.6509 21.2026 13.5 20 13.5C18.7975 13.5 17.7932 12.6509 17.5541 11.5196",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActiveClosed);
export default __webpack_public_path__ + "static/media/icon-notification-active-closed.c161992bebe3e1ddad8d5f69814b48d7.svg";
export { ForwardRef as ReactComponent };